import {Injectable, EventEmitter} from '@angular/core'
import { HttpClient } from '@angular/common/http';
import {MEAT_API} from '../app.api'
import { Resposta } from '../app.response';
import { Router } from '@angular/router'
import { LoginModel } from '../login/login-model';
import { ProdutoModel } from './produto-model';
import { MessageService } from 'primeng/api';

@Injectable()
export class ServicesProduto {
    
    constructor(private http : HttpClient, private router:Router,  private messageService: MessageService){}

    private usuarioAutenticado:boolean = false;

    mostrarMenu = new EventEmitter<boolean>();

    onUpload(uploadedFiles:File, produto:string){
        try {
            const fd = new FormData();
            fd.append('image', uploadedFiles, uploadedFiles.name);
            return this.http.post<Resposta<ProdutoModel>>(`${MEAT_API}/api/produto/uploadFotoProduto/${produto}`, fd);
        } catch (error) {
            this.messageService.add({severity:'error', summary:'Informação', detail: error});
             console.log(error);
        }       
     }

    gravarDadosProduto(dados:ProdutoModel){
        return this.http.post<Resposta<ProdutoModel>>(`${MEAT_API}/api/produto/cadastrarProduto/`, dados);
    }
    removerDadosProduto(dados:ProdutoModel){
        return this.http.post<Resposta<ProdutoModel>>(`${MEAT_API}/api/produto/removerProduto/`, dados);
    }
    listarProdutos(){
        return this.http.get<Resposta<ProdutoModel[]>>(`${MEAT_API}/api/produto/buscaProduto`);
    }

    listarProdutosFiltros(filtro:ProdutoModel){
        return this.http.post<Resposta<ProdutoModel[]>>(`${MEAT_API}/api/produto/buscaProdutoFiltros/`, filtro);
    }
}